import * as Shared from "./DocumentManager.shared";
import { DatabaseManager } from "@/lib/database/DatabaseManager.client";
import { IDocumentManager } from "./IDocumentManager";
import { DocumentRow } from "@/lib/types";

export class DocumentManager implements IDocumentManager {
  private client: ReturnType<typeof DatabaseManager.createBrowserClient>;

  constructor() {
    this.client = DatabaseManager.createBrowserClient();
  }

  async getDocument(documentId: string): Promise<DocumentRow | null> {
    return Shared.getDocument(this.client, documentId);
  }

  async getDocuments(
    tenantId: string,
    options: {
      isPublished?: boolean;
      isArchived?: boolean;
      docType?: string;
      search?: string;
      document_year?: number[];
      excludeCurrentYears?: boolean;
    } = {}
  ): Promise<DocumentRow[]> {
    return Shared.getDocuments(this.client, tenantId, options);
  }

  async analyzeDocument({
    tenantSlug,
    fileName,
    documentId,
  }: {
    tenantSlug: string;
    fileName: string;
    documentId: string;
  }): Promise<void> {
    // Client-side stub - this should not be called on the client
    throw new Error("analyzeDocument is not available on the client side");
  }

  async getSignedUrl(
    bucket: string,
    storagePath: string,
    expiresIn?: number
  ): Promise<string | null> {
    // Client-side stub - this should not be called on the client
    throw new Error("getSignedUrl is not available on the client side");
  }

  async generateUploadUrl(
    bucket: string,
    storagePath: string,
    contentType: string
  ): Promise<string> {
    // Client-side stub - this should not be called on the client
    throw new Error("generateUploadUrl is not available on the client side");
  }

  async insertDocument(
    metadata: Omit<DocumentRow, "id" | "uploaded_at">
  ): Promise<string> {
    // Client-side stub - this should not be called on the client
    throw new Error("insertDocument is not available on the client side");
  }

  async uploadDocument(
    bucket: string,
    storagePath: string,
    buffer: Buffer,
    contentType: string
  ): Promise<void> {
    // Client-side stub - this should not be called on the client
    throw new Error("uploadDocument is not available on the client side");
  }

  async updateDocumentStoragePath(
    documentId: string,
    storagePath: string
  ): Promise<void> {
    // Client-side stub - this should not be called on the client
    throw new Error(
      "updateDocumentStoragePath is not available on the client side"
    );
  }
}
